import { LogOut } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconLogOut12Line = createIcon(LogOut, 12, "Line");
export const IconLogOut16Line = createIcon(LogOut, 16, "Line");
export const IconLogOut20Line = createIcon(LogOut, 20, "Line");
export const IconLogOut24Line = createIcon(LogOut, 24, "Line");
export const IconLogOut32Line = createIcon(LogOut, 32, "Line");
export const IconLogOut48Line = createIcon(LogOut, 48, "Line");
export const IconLogOut64Line = createIcon(LogOut, 64, "Line");
